import React from "react";

export default function RestlessBodyContentFormatter(cellContent) {
  const body = cellContent;
  let json;

  if (body) {
    try {
      json = JSON.parse(body);
    } catch (error) {
      console.error(error);
    }
  }

  return <div>{json.text}</div>;
}
